module.exports = __webpack_public_path__ + "static/media/banner.d0caf3e6.jpg";